import React, { useState, useRef, useEffect } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import './ThemeToggle.css';

const ThemeToggle: React.FC = () => {
  const { mode, actualTheme, setMode } = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const getIcon = () => {
    if (mode === 'system') {
      return actualTheme === 'dark' ? '🌙' : '☀️';
    }
    return mode === 'dark' ? '🌙' : '☀️';
  };

  const getLabel = () => {
    switch (mode) {
      case 'light':
        return 'Clair';
      case 'dark':
        return 'Sombre';
      case 'system':
        return 'Système';
    }
  };

  const options = [
    { value: 'light' as const, label: 'Clair', icon: '☀️' },
    { value: 'dark' as const, label: 'Sombre', icon: '🌙' },
    { value: 'system' as const, label: 'Système', icon: '💻' },
  ];

  return (
    <div className="theme-toggle" ref={dropdownRef}>
      <button
        className="theme-toggle-button"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Changer le thème"
        aria-expanded={isOpen}
        title={getLabel()}
      >
        <span className="theme-icon">{getIcon()}</span>
        <svg
          className={`theme-chevron ${isOpen ? 'open' : ''}`}
          width="10"
          height="10"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3 4.5L6 7.5L9 4.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {isOpen && (
        <div className="theme-dropdown">
          {options.map((option) => (
            <button
              key={option.value}
              className={`theme-option ${mode === option.value ? 'active' : ''}`}
              onClick={() => {
                setMode(option.value);
                setIsOpen(false);
              }}
            >
              <span className="theme-option-icon">{option.icon}</span>
              <span className="theme-option-label">{option.label}</span>
              {mode === option.value && (
                <svg
                  className="theme-check"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.5 4.5L6 12L2.5 8.5"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ThemeToggle;